import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Loader2, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

export const CheckoutConsentDialog = ({ open, onOpenChange, onConfirm, label, price, loading }) => {
  const [ticked, setTicked] = useState(false);

  const handleChange = (next) => {
    if (!next) setTicked(false);
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleChange}>
      <DialogContent
        className="bg-[#0a070d] border border-purple-500/50 text-white max-w-md p-0 gap-0 shadow-[0_0_40px_rgba(168,85,247,0.35)]"
        data-testid="checkout-consent-dialog"
      >
        <div className="px-6 pt-6 pb-5 border-b border-zinc-800">
          <div className="text-purple-300 text-[10px] tracking-[0.35em] uppercase font-mono mb-2">One last step</div>
          <DialogTitle className="font-display text-2xl font-black tracking-tight">
            {label}{price ? <span className="text-purple-400"> · {price}</span> : null}
          </DialogTitle>
          <DialogDescription className="text-zinc-400 text-sm mt-2 leading-relaxed">
            Tick the box below and you&apos;ll go straight to secure Stripe payment.
          </DialogDescription>
        </div>

        <div className="px-6 py-5">
          <label className="flex items-start gap-3 cursor-pointer text-zinc-300 text-sm leading-relaxed">
            <input
              type="checkbox"
              checked={ticked}
              onChange={(e) => setTicked(e.target.checked)}
              className="mt-1 w-5 h-5 accent-purple-500 shrink-0 cursor-pointer"
              data-testid="checkout-consent-dialog-checkbox"
              autoFocus
            />
            <span>
              <span className="text-white font-semibold">I agree to immediate access.</span>{" "}
              The vault opens the moment I pay. Every purchase is covered by a{" "}
              <span className="text-purple-300">14-day no-questions refund</span> — contact Stag Vault via the contact form within 14 days for a full refund.{" "}
              <Link to="/refund-policy" className="text-purple-300 hover:text-purple-200 underline">Refund Policy</Link>.
            </span>
          </label>

          <button
            type="button"
            onClick={onConfirm}
            disabled={!ticked || loading}
            className="mt-5 w-full bg-purple-500 hover:bg-purple-400 text-black px-6 py-4 text-sm tracking-[0.25em] uppercase font-bold transition-all duration-300 shadow-[0_0_25px_rgba(168,85,247,0.4)] disabled:opacity-40 disabled:cursor-not-allowed inline-flex items-center justify-center gap-3"
            data-testid="checkout-consent-dialog-continue"
          >
            {loading ? (<><Loader2 size={16} className="animate-spin" /> Redirecting...</>) : (<>Continue to secure payment <ArrowRight size={16} /></>)}
          </button>
          <p className="mt-3 text-zinc-500 text-[11px] tracking-wide text-center inline-flex w-full items-center justify-center gap-1.5">
            <ShieldCheck size={12} className="text-purple-400" /> Powered by Stripe · Card details never touch our servers
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
